import { render, staticRenderFns } from "./VehicleSummary.vue?vue&type=template&id=0a53e994&"
import script from "./VehicleSummary.vue?vue&type=script&lang=js&"
export * from "./VehicleSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports